<!--
 * @Description: 侧边菜单导航
 * @Author: xiawenlong
 * @Date: 2021-04-20 10:44:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2023-03-06 09:58:36
-->
<template>
  <div class="menu" @mousewheel.stop>
    <el-scrollbar>
      <el-menu
        :default-active="activeMenu"
        background-color="#FFF"
        text-color="#666666"
        active-text-color="#ffffff"
        mode="vertical"
        :collapse-transition="false"
        :collapse="opened"
      >
        <!-- <div v-for="item in routes" :key="item.path">
          <side-menu-item :item="item" :base-path="item.path"></side-menu-item>
        </div> -->
        <div v-for="item in menuList" :key="item.path">
          <side-menu-item :item="item" :base-path="item.path"></side-menu-item>
        </div>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import SideMenuItem from './SideMenuItem'
import { mapGetters } from 'vuex'
import to from 'await-to'
import { getMenu } from '@/api/login'
export default {
  components: { SideMenuItem },
  data() {
    return {
      routes: this.$router.options.routes,
      clientCode: '52817232-63e9-11ed-a8c9-506b4b42',
      menuList: [],
    }
  },
  computed: {
    ...mapGetters(['opened', 'menuType']),
    activeMenu() {
      return this.$route.path
    },
  },
  created() {
    this.getMenuData()
  },
  methods: {
    async getMenuData() {
      const [res, err] = await to(getMenu({ clientCode: this.clientCode, organizationId: 3237 }))
      if (err) return this.$message.warning(err.msg)
      this.menuList = res.data
    },
  },
}
</script>
